import Vue from 'vue';

const baseURL = window.baseURL || 'http://erpapi.goldenphoenix.hk/api/'//演示版，
// const baseURL = 'http://192.168.3.209/api/'//本地局域网

Vue.prototype.$baseURL = baseURL;
export default baseURL